import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31.788",
  height: "33.142"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7904",
  d: "M4 6v9.992s0 5 11.658 5 11.658-5 11.658-5V6",
  transform: "translate(-3.25 -.254)",
  style: {"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7905",
  d: "M15.658 3c11.657 0 11.657 5 11.657 5s0 5-11.658 5S4 8 4 8s0-5 11.658-5z",
  style: {"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},
  transform: "translate(-3.25 -2.25)"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7906",
  d: "M15.658 26.989C4 26.989 4 21.992 4 21.992V12",
  transform: "translate(-3.25 3.739)",
  style: {"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7907",
  d: "M21 25.992V16m0 0 5 5m-5-5-5 5",
  transform: "translate(4.735 6.4)",
  style: {"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render };